__webpack_require__.p = "/issues/41/paper-bullets/";